var _rect, _ellipse, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgServices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 208,
    height: 215,
    viewBox: "0 0 208 215",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    width: 200,
    height: 200,
    fill: "url(#pattern0)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 104,
    cy: 207.5,
    rx: 104,
    ry: 7.5,
    fill: "#A7ADB2"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_0_1",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_0_1",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAAAXNSR0IArs4c6QAAAxxJREFUeAHtnL9rFEEUgLfWQhtLESs5EGxErxBCGmv/A20lhX+AxQargMVV9oF09qk3pa0gIugfkN5CrEZfiMPeMXO7c8nb99b5Dh6Zm9v5ke+bt7tzl0vT8IAABCAAAQhAAAIQgECdBO48f39G6DMYvbruHXwOj99+Cc/efSUUGAhbYVwk5LD7GY6/B0KBgbBFiALYXRcsQhzJEIkIQQjXnm2nMzKEDCFDyBBnWWAi5NXJediM1EQ2j5HnVzku1XZOdWrXENncbEYKzOYx8vwqx6XazqkOIc5OZwhByPpdFqesdR5qGXLdF+ux/c3pepGaq5qQ1GDUrWdDigdCarmGpOxTR4Yk9zSeFwanLE5Zw2nreQVrz40MIUPIkG1ZtlOGPG2/hf2jH4QCA2Er716M/jOg209ehzcfPoXV6TmhwEDYCuPRQpqmCV3XBR46BIStMEaIDt/iXhFSjEy3AUJ0+Rb3jpBiZLoNEKLLt7h3hBQj022gJuTy1u3fLdzkP9u23UrOan5bJxXCxZZC5bZXOn35YhXag27yuH/3URgSIivRIkyFiIyPqzB5PHywNyhkCIzV66qnLISUa0VIOTPVFghRxVveOULKmam2QIgq3vLOEVLOTLUFQlTxlnderZAqd+qe9yGyEi1iKGeqzZAhMFavI8SKfGZchGTAWFUjxIp8ZlyEZMBYVSPEinxmXIRkwFhVI8SKfGbcaoWwU5/wo9wxH+HKSrSITGLE6mozJBJwVkAIQvT/CmXMKcuZhzgdMiSi8FFAiA8PcRYIiSh8FBDiw0OcBUIiCh+FaoWwU2enfvHOwFAeVpshQ2CsXkeIFfnMuAjJgLGqRogV+cy4CMmAsapGiBX5zLgIyYCxqkaIFfnMuNUKqXKnLt8Xlw+Lpo6bN24Nfi1aVqJFZBIjVqtliHxx3zLkF5vjQ03IHGF4mDNCPFjozQEhPRgeigjxYKE3B4T0YHgoIsSDhd4cENKD4aGIEA8WenPYSchisfi9XC5/EdfPQNhevq0z+p9bH/49ktBnMFoIB0IAAhCAAAQgAAEIQOA/IvAHd7oyi1x3xfEAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServices);
export default __webpack_public_path__ + "static/media/services.58d85473373dba1e82d78e4621329ed6.svg";
export { ForwardRef as ReactComponent };